import React from 'react'

import students from '../../../../images/education/internship.jpg'

import styles from './styles.module.scss'
import { Link } from 'react-router-dom'
import vector_right from "../../../../images/basic/header/vector_right.svg";

const InfoBlockEducation = () => {
  return (
    <div className={styles.wrapper}>
      {/*<div className={styles.wr1}>*/}
      {/*  <div className={styles.left}>*/}
      {/*    <p className={styles.title}>Возможности для студентов</p>*/}
      {/*  </div>*/}
      {/*</div>*/}
      <div className={styles.wr2}>
        <div className={styles.left}>
          <p className={styles.title}>Возможности для студентов</p>
          <img src={students} alt='students' draggable='false'/>
        </div>
        <div className={styles.right}>
          <div className={styles.desc}>
            <div className={styles.title}>
              Хочешь получить реальный опыт работы ещё до окончания вуза?
            </div>
            <div class={styles.img_mobile}>
              <img src={students} alt='students' draggable='false'/>
            </div>
            <div className={styles.preview}>
              <p className={styles.text}>
                На стажировке в компании тебя ждут интересные задачи, новейшее оборудование и общение с опытными наставниками.
              </p>
            </div>
            <div className={styles.down}>
              <div className={styles.down_wrapper}>
                <Link to='/students/internShips' className={styles.button}>
                  Узнать больше о стажировках
                  <img className={styles.vector_right} src={vector_right} alt='vector' draggable='false'/>
                </Link>
              </div>
            </div>
          </div>
          <div className={styles.img}>
            <img src={students} alt='students' draggable='false'/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InfoBlockEducation
